import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { MedioPagoVentasSelect } from 'sharedComponents/select'

const MedioPago1FormGroup = ({ iError, iTouched }) => {
  return (
    <Form.Group>
      <Col md={12}>
        <Field name='medioPago1'>
          {({ field }) => <MedioPagoVentasSelect {...field} disabled isInvalid={iTouched && iError} id='input-medioPago1' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MedioPago1FormGroup)
